module.exports = __webpack_public_path__ + "static/media/karet-down-light.693c1373.svg";